// extracted by mini-css-extract-plugin
export default {"toastBox":"S2doHT","icon":"Y9eM_h","text":"rt96cr"};